export default {
    props:{
        hiddenViewport:{
            type:String,
            default: null
        },
        showViewport:{
            type:String,
            default: null
        }
    },
    computed: {
        showViewportClass(){
            let str = '';
            let viewports = ['xs','sm', 'md','lg', 'xl'];
            if(this.hiddenViewport){
                let hiddenVp = this.hiddenViewport.split('|');
                hiddenVp.forEach(vp => str = `${str} d-${vp}-none`);
                let showVp = viewports.filter(vp => !hiddenVp.includes(vp));
                showVp.forEach(vp => str = `${str} d-${vp}-block`);
            }else if(this.showViewport){
                let showVp = this.showViewport.split('|');
                showVp.forEach(vp => str = `${str} d-${vp}-block`);
                let hiddenVp = viewports.filter(vp => !showVp.includes(vp));
                hiddenVp.forEach(vp => str = `${str} d-${vp}-none`);
            }
            return str;
        }
    },
};